import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../core/api/endpoints';
import { AppState } from '../../core/redux/appState';
import { RaterApprovalRater } from '../models';


const KEY_ACTION = ActionType.RaterApprovalRatersRequest;
const ACTIONS    = [
  ActionType.RaterApprovalRatersRequest,
  ActionType.RaterApprovalRatersResponse,
  ActionType.RaterApprovalRatersError,
];


type Payload = RaterApprovalRater[];


type Meta = {
  participantId: number;
  projectId: number;
};


/**
 * Dispatch this to retrieve all the participants whose raters the current user has been assigned to approve
 *
 * @param participantId - the user's database Id
 * @param projectId - the user's database Id
 */
export const raterApprovalRatersAction = (
  participantId: number,
  projectId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.RaterApprovalRaters,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({ participantId, projectId }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { participantId, projectId }),
    bailout:  (state: AppState) => !!getLoading(state, KEY_ACTION, `${participantId}-${projectId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const participantId = action.meta.participantId;
  const projectId     = action.meta.projectId;
  const metaTag       = `${participantId}-${projectId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  return R.assocPath(['raterApprovalRaters', `${participantId}`, `${projectId}`], payload, successState);
};

export const raterApprovalRatersReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
